
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/installer-guide",
      function () {
        return require("private-next-pages/installer-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/installer-guide"])
      });
    }
  